import HeaderRegister from "../../../../components/header/register";
import FormFiscalConfig from "../form";

const MainRegisterFiscalConfig = () => {
	const options = {
		title: "Configuração Fiscal",
		subTitle: "Cadastro",
	};

	return (
		<div className="mt-page">
			<HeaderRegister title={options.title} subTitle={options.subTitle} />
			<FormFiscalConfig />
		</div>
	);
};

export default MainRegisterFiscalConfig;
